const configRoutes = {
  navRoutes: [
    {
      id: 1,
      routeName: 'Artists',
      routePath: '/artists'
    },
    {
      id: 2,
      routeName: 'Archive',
      routePath: '/archive'
    },
    {
      id: 3,
      routeName: 'Discover',
      routePath: '/discover'
    },
    {
      id: 4,
      routeName: 'Schedule',
      routePath: '/schedule'
    },
    // {
    //   id: 5,
    //   routeName: 'About',
    //   routePath: '/about'
    // }
  ],
  appNavSubRoutes: { // this objects renders <AppNavSub> Vue component
    archive: [
      {
        id: 1,
        routeName: 'Latest',
        title: 'Latest',
        to: {name: 'Latest'},
        enabled: true,
        type: 'archive',
        children: [],
        filters: {
          alphabet : false,
          artistIndex: false,
          frequency: false
        }
      },
      {
        id: 2,
        routeName: 'ShowsAll',
        title: 'Shows',
        to: {name: 'ShowsAll'},
        enabled: true,
        type: 'archive',
        children: ['ShowsId'],
        filters: {
          alphabet : true,
          artistIndex: false,
          frequency: false
        }
      },
      {
        id: 3,
        routeName: 'SeriesAll',
        title: 'Series',
        to: {name: 'SeriesAll'},
        enabled: true,
        type: 'archive',
        children: ['SeriesId'],
        filters: {
          alphabet : true,
          artistIndex: false,
          frequency: false
        }
      },
    ],
    artists: [
      {
        id: 1,
        routeName: 'Residents',
        title: 'Residents',
        to: {name: 'Residents'},
        enabled: true,
        type: 'artist',
        children: ['ResidentsId', 'ResidentsFrequency'],
        filters: {
          alphabet : true,
          artistIndex: true,
          frequency: true
        }
      },
      {
        id: 2,
        routeName: 'Guests',
        title: 'Guests',
        to: {name: 'Guests'},
        enabled: true,
        type: 'artist',
        children: ['GuestsId'],
        filters: {
          alphabet : true,
          artistIndex: true,
          frequency: false
        }
      },
    ],
    discover: [
      {
        id: 1,
        routeName: 'discover-genres',
        title: 'Genres',
        to: {name: 'discover-genres', query: {q: 'genres'}},
        enabled: false,
        type: 'genre',
        filters: {
          alphabet : false,
          artistIndex: false,
          frequency: false
        }
      },
      {
        id: 2,
        routeName: 'discover-genres',
        title: 'Subjects',
        to: {name: 'discover-genres', query: {q: 'subjects'}},
        enabled: false,
        type: 'genre',
        filters: {
          alphabet : false,
          artistIndex: false,
          frequency: false
        }
      },
      {
        id: 3,
        routeName: 'discover-location',
        title: 'Locations',
        to: {name: 'discover-location'},
        enabled: true,
        type: 'location',
        filters: {
          alphabet : false,
          artistIndex: false,
          frequency: false
        }
      }
    ],
  },
  archiveRoutes: [
    {
      id: 1,
      routeName: 'Latest',
      routePath: '/archive/latest'
    },
    {
      id: 2,
      routeName: 'Shows',
      routePath: '/archive/shows'
    },
    {
      id: 3,
      routeName: 'Series',
      routePath: '/archive/series'
    },
  ],
  socialRoutes: [
    {
      id: 1,
      routeName: 'Instagram',
      routePath: 'https://www.instagram.com/stegiradio/'
    },
    {
      id: 2,
      routeName: 'Facebook',
      routePath: 'https://www.facebook.com/stegi.radio/'
    }
  ],
  artistsRoutes:[
    {
      id: 1,
      routeName: 'Residents',
      routePath: '/artists/residents'
    },
    {
      id: 2,
      routeName: 'Guests',
      routePath: '/artists/guests'
    },
  ],
  locationRoutes: [
    {
      id: 1,
      title: 'Artists',
      entity: 'residents',
      name: 'location-id-residents',
      subNav: [
        {
          id: 11,
          title: 'Residents',
          entity: 'residents',
          name: 'location-id-residents'
        },
        {
          id: 12,
          title: 'Guests',
          entity: 'guests',
          name: 'location-id-guests'
        }
      ]
    },
    {
      id: 2,
      title: 'Episodes',
      entity: 'episodes',
      name: 'location-id-episodes'
    },
    {
      id: 3,
      title: 'Shows',
      entity: 'shows',
      name: 'location-id-shows'
    }

  ],
  locationFilters: [
    {
      id: 100,
      title: 'Residents',
      name:'location-id-residents'
    },
    {
      id: 101,
      title: 'Guests',
      name:'location-id-guests'
    },
    {
      id: 102,
      title: 'Episodes',
      name:'location-id-episodes'
    },
    {
      id: 103,
      title: 'Shows',
      name:'location-id-shows'
    }
  ]
};
export default configRoutes;
